import { Outcome } from './Outcome';
import { SceneOutcomeRelation } from '../SceneOutcomeRelation';

export class OutcomeInScene{
    outcome: Outcome;
    sceneOutcomeRelation: SceneOutcomeRelation;
}